<!-- //
Form块的标题
@auth xuyd
@date 2024-05-05
//-->
<template>
  <div class="card" :style="{'background-color': backgroundColor, 'border-left-color': iconColor}">
    <span class="title" :style="{'color': fontColor}">{{ title }}</span>
  </div>
</template>

<script>

export default {
  name: 'CompFormTitle',
  data() {
    return {}
  },
  props: {
    title: [String, Number],
    backgroundColor: {
      type: String,
      default: '#34363d'
    },
    iconColor: {
      type: String,
      default: '#409eff'
    },
    fontColor: {
      type: String,
      default: '#409eff'
    },
  }
}
</script>

<style lang="less" scoped>
.card {
  width: 100%;
  color: #fedb8b;
  font-size: 12px;
  height: 24px;
  line-height: 24px;
  text-align: left;
  border-left: 4px solid;
  .title {
    color: #5a9ade;
    padding-left: 4px;
  }
}
</style>
